export default __webpack_public_path__ + "static/media/Arrow Up.9a476698.svg";